<div class="consent">
  @switch (state) {
    @case ('loading') {
      <app-orbi-loader [size]="96"></app-orbi-loader>
    }
    @case ('ask') {
      <nb-icon icon="orbi" pack="al" class="consent__orbi"></nb-icon>
      <h2>{{ 'pages.oauthConsent.title' | translate: { client: info!.client_name } }}</h2>
      <p class="consent__who">
        {{ 'pages.oauthConsent.signedInAs' | translate: { email: info!.user.email || info!.user.name || '' } }}
      </p>

      <ul class="consent__list">
        <li>{{ 'pages.oauthConsent.read' | translate }}</li>
        <li>{{ 'pages.oauthConsent.noSecrets' | translate }}</li>
        <li>
          @switch (info!.redirect.kind) {
            @case ('device') { {{ 'pages.oauthConsent.targetDevice' | translate }} }
            @case ('app') { {{ 'pages.oauthConsent.targetApp' | translate: { target: info!.redirect.target } }} }
            @default { {{ 'pages.oauthConsent.targetWeb' | translate: { target: info!.redirect.target } }} }
          }
        </li>
      </ul>

      <div class="consent__write">
        <nb-toggle [(checked)]="canWrite" status="primary">{{ 'pages.oauthConsent.canWrite' | translate }}</nb-toggle>
        <p class="consent__hint">{{ 'pages.oauthConsent.canWriteHint' | translate }}</p>
      </div>

      <p class="consent__hint">{{ 'pages.oauthConsent.revokeHint' | translate }}</p>
      @if (failed) {
        <p class="consent__error">{{ 'pages.oauthConsent.failed' | translate }}</p>
      }

      <div class="consent__actions">
        <button nbButton status="basic" type="button" [nbSpinner]="busy === 'deny'" [disabled]="!!busy" (click)="decide(false)">
          {{ 'pages.oauthConsent.deny' | translate }}
        </button>
        <button nbButton status="primary" type="button" [nbSpinner]="busy === 'approve'" [disabled]="!!busy" (click)="decide(true)">
          {{ 'pages.oauthConsent.approve' | translate }}
        </button>
      </div>
    }
    @case ('disabled') {
      <h2>{{ 'pages.oauthConsent.disabledTitle' | translate }}</h2>
      <p>{{ 'pages.oauthConsent.disabled' | translate }}</p>
      <button nbButton status="basic" type="button" [nbSpinner]="busy === 'deny'" [disabled]="!!busy" (click)="decide(false)">
        {{ 'pages.oauthConsent.backToAgent' | translate }}
      </button>
    }
    @case ('leaving') {
      <h2>{{ 'pages.oauthConsent.leavingTitle' | translate }}</h2>
      <p>{{ 'pages.oauthConsent.leaving' | translate }}</p>
    }
    @case ('framed') {
      <h2>{{ 'pages.oauthConsent.goneTitle' | translate }}</h2>
      <p>{{ 'pages.oauthConsent.framed' | translate }}</p>
    }
    @default {
      <h2>{{ 'pages.oauthConsent.goneTitle' | translate }}</h2>
      <p>{{ 'pages.oauthConsent.gone' | translate }}</p>
      <a class="consent__link" routerLink="/">{{ 'pages.oauthConsent.toPortal' | translate }}</a>
    }
  }
</div>
